module.exports = __webpack_public_path__ + "video_author_orange-ddf372b8.svg";